import { SyncStatus } from "~/gql/types2";
import { StructuralFolder } from "./types";

export function filterByNeedsAttention(
  folders: StructuralFolder[]
): StructuralFolder[] {
  return folders
    .map((structural) => {
      const clientFolders = structural.clientFolders
        .map((client) => ({
          ...client,
          projectFolders: client.projectFolders.filter(
            (f) =>
              f.syncStatus === SyncStatus.PendingMove ||
              f.syncStatus === SyncStatus.Error ||
              f.syncStatus === SyncStatus.RenameFailed
          ),
          groupedFolders: client.groupedFolders.filter(
            (f) =>
              f.syncStatus === SyncStatus.PendingMove ||
              f.syncStatus === SyncStatus.Error
          ),
        }))
        .filter(
          (client) =>
            client.syncStatus === SyncStatus.Error ||
            client.syncStatus === SyncStatus.RenameFailed ||
            client.projectFolders.length > 0 ||
            client.groupedFolders.length > 0
        );

      return { ...structural, clientFolders };
    })
    .filter((structural) => structural.clientFolders.length > 0);
}
